import component from './recollectQueries.vue'

export default component
